import React from 'react';
import { Link } from 'react-router-dom';

const ConsultationCTA = () => {
  return (
    <section
      style={{
        backgroundColor: '#f8f9fa',
        padding: '80px 20px',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
      }}
    >
      {/* SEO-OPTIMIZED H2 with NEW KEYWORDS */}
      <h2
        style={{
          fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
          fontWeight: '700',
          marginBottom: '20px',
          color: '#1A1A1A',
          lineHeight: '1.3',
        }}
      >
        Start Medical Billing Outsourcing for Your Small Practice Today
      </h2>

      {/* Supporting paragraph with keywords */}
      <p style={{
        fontSize: '1.15rem',
        maxWidth: '800px',
        margin: '0 auto 30px',
        lineHeight: '1.7',
        color: '#555',
      }}>
        Experience expert{' '}
        <Link 
          to="/revenue-cycle-management-independent-physicians"
          style={{ color: '#0077b6', textDecoration: 'underline', fontWeight: '600' }}
        >
          revenue cycle management for independent physicians
        </Link>{' '}
        and multispecialty clinics. Join 200+ practices that have reduced costs by 30-50% with our{' '}
        <Link 
          to="/medical-billing-outsourcing-small-practices"
          style={{ color: '#0077b6', textDecoration: 'underline', fontWeight: '600' }}
        >
          medical billing outsourcing services
        </Link>.
      </p>

      <p style={{
        fontSize: '1.05rem',
        maxWidth: '700px',
        margin: '0 auto 40px',
        lineHeight: '1.7',
        color: '#666',
      }}>
        Get expert{' '}
        <Link 
          to="/denial-management-services-medical-clinics"
          style={{ color: '#0077b6', textDecoration: 'underline', fontWeight: '600' }}
        >
          denial management services
        </Link>{' '}
        to{' '}
        <Link 
          to="/reduce-claim-denials-healthcare-billing"
          style={{ color: '#0077b6', textDecoration: 'underline', fontWeight: '600' }}
        >
          reduce claim denials in healthcare billing
        </Link>{' '}
        by 35-45%. Experience all{' '}
        <Link 
          to="/benefits-medical-billing-outsourcing-clinics"
          style={{ color: '#0077b6', textDecoration: 'underline', fontWeight: '600' }}
        >
          benefits of medical billing outsourcing for clinics
        </Link>.
      </p>

      <Link to="/free-trial">
        <button
          style={{
            backgroundColor: '#F26522',
            color: '#ffffff',
            padding: '16px 40px',
            fontSize: '1.1rem',
            border: 'none',
            borderRadius: '30px',
            cursor: 'pointer',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            boxShadow: '0 6px 20px rgba(242, 101, 34, 0.3)',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#d3541c';
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 8px 25px rgba(242, 101, 34, 0.4)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = '#F26522';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 6px 20px rgba(242, 101, 34, 0.3)';
          }}
        >
          Get Free Trial - Small Practices Welcome
        </button>
      </Link>

      {/* Additional trust signals with SERVICE LINKS */}
      <div style={{
        marginTop: '40px',
        display: 'flex',
        justifyContent: 'center',
        gap: '40px',
        flexWrap: 'wrap',
        maxWidth: '900px',
        margin: '40px auto 0',
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '2rem', fontWeight: '700', color: '#0077b6' }}>200+</div>
          <div style={{ fontSize: '0.95rem', color: '#666', marginBottom: '5px' }}>
            Small Practices & Clinics
          </div>
          <Link 
            to="/medical-billing-outsourcing-small-practices"
            style={{ fontSize: '0.85rem', color: '#0077b6', textDecoration: 'underline' }}
          >
            View Solutions
          </Link>
        </div>
        
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '2rem', fontWeight: '700', color: '#0077b6' }}>45%</div>
          <div style={{ fontSize: '0.95rem', color: '#666', marginBottom: '5px' }}>
            Reduction in Claim Denials
          </div>
          <Link 
            to="/reduce-claim-denials-healthcare-billing"
            style={{ fontSize: '0.85rem', color: '#0077b6', textDecoration: 'underline' }}
          >
            Learn How
          </Link>
        </div>
        
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '2rem', fontWeight: '700', color: '#0077b6' }}>98%</div>
          <div style={{ fontSize: '0.95rem', color: '#666', marginBottom: '5px' }}>
            Client Satisfaction Rate
          </div>
          <Link 
            to="/benefits-medical-billing-outsourcing-clinics"
            style={{ fontSize: '0.85rem', color: '#0077b6', textDecoration: 'underline' }}
          >
            See Benefits
          </Link>
        </div>
      </div>

      {/* Practice Type Links */}
      <div style={{
        marginTop: '40px',
        padding: '30px',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        maxWidth: '800px',
        margin: '40px auto 0',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      }}>
        <h3 style={{
          fontSize: '1.3rem',
          fontWeight: '600',
          marginBottom: '20px',
          color: '#333',
        }}>
          🎯 Find Your Solution
        </h3>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '15px',
        }}>
          <Link 
            to="/medical-billing-outsourcing-small-practices"
            style={{
              padding: '15px 20px',
              backgroundColor: '#e8f5e9',
              color: '#2e7d32',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '0.95rem',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              border: '1px solid #4caf50',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#2e7d32';
              e.currentTarget.style.color = '#ffffff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#e8f5e9';
              e.currentTarget.style.color = '#2e7d32';
            }}
          >
            👥 Small Practices
          </Link>

          <Link 
            to="/revenue-cycle-management-independent-physicians"
            style={{
              padding: '15px 20px',
              backgroundColor: '#e3f2fd',
              color: '#1565c0',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '0.95rem',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              border: '1px solid #2196f3',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#1565c0';
              e.currentTarget.style.color = '#ffffff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#e3f2fd';
              e.currentTarget.style.color = '#1565c0';
            }}
          >
            👨‍⚕️ Independent Physicians
          </Link>

          <Link 
            to="/revenue-cycle-management-multispecialty-practices"
            style={{
              padding: '15px 20px',
              backgroundColor: '#fff3e0',
              color: '#e65100',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '0.95rem',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              border: '1px solid #ff9800',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#e65100';
              e.currentTarget.style.color = '#ffffff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#fff3e0';
              e.currentTarget.style.color = '#e65100';
            }}
          >
            🏢 Multispecialty Clinics
          </Link>
        </div>
      </div>

      <p style={{
        fontSize: '0.9rem',
        color: '#999',
        marginTop: '30px',
        fontStyle: 'italic',
      }}>
        No credit card required • Free 30-day trial • Perfect for small practices • Cancel anytime
      </p>
    </section>
  );
};

export default ConsultationCTA;